/***
 *
 *   CARD STYLES
 *   Ported from ui-reference/src/components/ui/card.tsx (cardVariants).
 *
 **********/

const Style = {
    base: 'rounded-lg border p-5 transition-colors mb-6',

    // -- variants ----------------------------------------------------------
    surface: 'bg-surface text-text-primary shadow-sm',
    elevated: 'bg-surface-elevated text-text-primary shadow-md',
    interactive:
        'bg-surface text-text-primary shadow-sm hover:border-primary-300 hover:shadow-md focus-within:ring-2 focus-within:ring-ring',

    // -- sub-parts ---------------------------------------------------------
    header: 'mb-3 space-y-1',
    title: 'text-lg font-semibold leading-none',
    description: 'text-sm text-text-secondary',
    footer: 'mt-4 flex items-center',

    // -- modifiers ---------------------------------------------------------
    center: 'mx-auto',
    loading: 'h-60',
    noPadding: '!p-0',
    restrictWidth: 'max-w-md',
    last: 'mb-0',
};

export default Style;
